import { render } from "./AppointmentsByDoctors.vue?vue&type=template&id=e4099a2a"
import script from "./AppointmentsByDoctors.vue?vue&type=script&lang=js"
export * from "./AppointmentsByDoctors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__